import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { of, BehaviorSubject, Observable } from "rxjs";
import { EmployeeService } from "app/api/services";
import {
  EmployeeResponse,
  TeamRole,
} from "app/api/models";
import { MsalService } from "@azure/msal-angular";
import { UserRoleService } from "app/views/calibrations/shared/services/auth/user-role.service";
import { Roles } from "app/views/calibrations/shared/models/roles.model";
import { LocalStoreService } from "app/core/services/local-store.service";


export interface StoredUserDto {
  id?: string;
  displayName?: string;
  role?: string
  firstName?: string;
  lastName?: string;
  email?: string;
  teamRole?: TeamRole | null;
  reportsToUserId?: number | null;
}

@Injectable({
  providedIn: "root",
})
export class AppAuthService {
  isAuthenticated: Boolean;
  user: StoredUserDto = {};
  user$ = new BehaviorSubject<StoredUserDto>(this.user);
  return: string;
  APP_USER = "NEXUS_USER";

  constructor(
    private employeeService: EmployeeService,
    private route: ActivatedRoute,
    private authService: MsalService,
    private userRoleService: UserRoleService,
    private ls: LocalStoreService,
  ) {
    this.route.queryParams.subscribe(
      (params) => (this.return = params["return"] || "/dashboard")
    );
  }

  async getAndSetUser() {
    var res = await this.employeeService.apiEmployeeEmployeeGet$Json$Response().toPromise();
    console.log("get and set user", res);
    if(!res?.body?.data)
      return;

    this.setUser(res.body.data);
  }

  setUser(employee: EmployeeResponse) {
    if(!employee) {
      this.clearUser();
      return;
    }

    this.user = {
      id: employee.id.toString(),
      displayName: `${employee.firstName} ${employee.lastName}`,
      role: employee.dlmAccessLevel,
      firstName: employee.firstName,
      lastName: employee.lastName,
      email: employee.email,
      teamRole: employee.teamRole,
      reportsToUserId: employee.reportsToUserId,
    };
    this.ls.setItem(this.APP_USER, this.user);
  }

  isLoggedIn(): boolean {
    return !!this.authService.instance.getActiveAccount();
  }

  isLoggedInObservable(): Observable<boolean> {
    return of(this.isLoggedIn());
  }

  isBasic() {
    return this.userRoleService.isRole(Roles.Engineer);
  }
  isCoordinator() {
    return this.userRoleService.isRole(Roles.Coordinator);
  }
  isAdmin() {
    return this.userRoleService.isRole(Roles.Admin) || this.isSuperAdmin();
  }
  isSuperAdmin() {
    return this.userRoleService.isRole(Roles.SuperAdmin) || this.isElevatedAdmin();
  }
  isElevatedAdmin() {
    // return ['paige.gray@elevated-software.co.uk', 'mitch.price@elevated-software.co.uk'].includes(this.getUser().email);
    return this.userRoleService.isRole(Roles.ElevatedAdmin);
  }

  getUser() {
    return this.ls.getItem(this.APP_USER);
  }

  clearUser() {
    this.ls.setItem(this.APP_USER, null);
  }
}
